import { render, staticRenderFns } from "./DictJba.vue?vue&type=template&id=f7962280&"
import script from "./DictJba.vue?vue&type=script&lang=js&"
export * from "./DictJba.vue?vue&type=script&lang=js&"
import style0 from "./DictJba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports